import React, { JSX } from 'react';

import { MobileFilterIcon } from '~/src/dash/components/icons/misc-icons';
import { MenuToggle } from '~/src/dash/components/toggles/MenuToggle';
import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  numActive: number;
  handleOnClick: () => void;
  isOpen: boolean;
}

export const DashboardFiltersToggle = ({
  numActive,
  handleOnClick,
  isOpen,
}: IProps): JSX.Element => {
  return (
    <MenuToggle
      isActive={isOpen}
      onClick={handleOnClick}
      SvgIcon={MobileFilterIcon}
      iconStyle={{ height: '13px' }}
      style={{ height: '30px' }}
    >
      <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
        <Col>
          <Text small bold color='inherit' tKey='Filters'>
            Filters
          </Text>
        </Col>
        {numActive > 0 && (
          <Col>
            <div
              style={{
                minWidth: '20px',
                borderRadius: '6px',
                backgroundColor: publicaColors.honeydew,
              }}
            >
              <Text extraSmall bold color='inherit'>
                {numActive}
              </Text>
            </div>
          </Col>
        )}
      </Cols>
    </MenuToggle>
  );
};
